/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Expired_DescriptionInputs */

const en_agent_authorization_expired_description = /** @type {(inputs: Agent_Authorization_Expired_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No access was granted. Ask the Agent to register the project again for a new link.`)
};

const zh_agent_authorization_expired_description = /** @type {(inputs: Agent_Authorization_Expired_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`系统没有授予权限。请让 Agent 重新注册项目并生成新链接。`)
};

/**
* | output |
* | --- |
* | "No access was granted. Ask the Agent to register the project again for a new link." |
*
* @param {Agent_Authorization_Expired_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_expired_description = /** @type {((inputs?: Agent_Authorization_Expired_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Expired_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_expired_description(inputs)
	return zh_agent_authorization_expired_description(inputs)
});
export { agent_authorization_expired_description as "agent.authorization.expired_description" }